<template>
    <div v-bind:id="`naver-pay-button-${uuid}`" oncontextmenu="return false;"></div>
</template>
<script>
import api from "@/api";
import detect from "@/plugins/detect";

let uuid = 0;
export default {
    beforeCreate() {
        uuid += 1;
    },
    props: {
        carts: { type: Array, default: null },
        buttonKey: String,
        type: { type: String, default: 'D' },
        color: { type: Number, default: 1 },
        count: { type: Number, default: 1 },
        disabled: { type: Boolean, default: false },
        pc: { type: Boolean, default: false },
        mobile: { type: Boolean, default: false },
    },
    data() {
        return {
            uuid,
            detect
        };
    },
    mounted(){
        this.init();
    },
    methods: {
        init(){
            if(window.naver){
                window.naver.NaverPayButton.apply({
                    BUTTON_KEY: "F8480FBE-500A-4BBE-AE78-D7A9AC6592E6",
                    TYPE: this.type, //버튼 스타일
                    COLOR: this.color, //버튼 색상타입
                    COUNT: this.count, // 네이버페이버튼 + 찜하기버튼 모두 출력 여부
                    ENABLE: 'Y', //네이버페이 활성여부(재고부족 등에는 N으로 비활성처리)
                    EMBED_ID: `naver-pay-button-${this.uuid}`, //네이버페이 버튼 UI가 부착될 HTML element의 ID
                    BUY_BUTTON_HANDLER: this.buy, 
                    WISHLIST_BUTTON_HANDLER: this.wishlist,
                });
            }
        },
        async buy(){
            try{
                let result = await api.plugins.naver.pay.order({carts: this.carts})

                window.open(result.returnUrl)
                this.$emit("update")
            }
            catch(error){
                console.error(error);
                if(error.response) alert(error.response.data.message);
                else alert(error.message);
            }
        },
        async wishlist(){
            try{
                var res = await this.$http.post("/api/naver/payment/wishlist", { _product: this.cart._product });

                switch(detect){
                    case "pc": {
                        window.open(res.data.pc_url, "wishlist", "scrollbars=yes,width=400,height=267");
                        break;
                    }
                    case "mobile": {
                        window.location.href = res.data.m_url;
                        break;
                    }
                }
            }
            catch(error){
                console.error(error);
                if(error.response) alert(error.response.data.message);
                else alert(error.message);
            }
        },
    }
}
</script>
